module.exports = __webpack_public_path__ + "static/media/212.e31302e7.png";